import React, { useEffect, useState, useContext } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import MetaTags from "react-meta-tags";
import SearchIcon from "@material-ui/icons/Search";
import GetNews from "../../components/card/GetNews";
import Pagination from "@material-ui/lab/Pagination";
import { getAllNews } from "../../action/news";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";
import "./hideScrollbar.css";

export default function News() {
  const [newsData, setNewsData] = useState({});
  const [initialNews, setInitialNews] = useState({});
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [idCategory, setIdCategory] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

    return (
      <button
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        style={{
          display: "flex",
          marginTop: "150px",
          marginRight: "10px",
          justifyContent: "center",
          alignItems: "center",
          height: "40px",
          width: "40px",
          backgroundColor: isFirstItemVisible ? "rgba(226, 232, 240, 0.6)" : "#0f172a",
          color: isFirstItemVisible ? "#94a3b8" : "#ffffff",
          borderRadius: "50%",
          border: "none",
          cursor: isFirstItemVisible ? "not-allowed" : "pointer",
          fontSize: "18px",
          fontWeight: "bold",
          zIndex: 2,
        }}
      >
        ‹
      </button>
    );
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);

    return (
      <button
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        style={{
          display: "flex",
          marginTop: "150px",
          marginLeft: "10px",
          justifyContent: "center",
          alignItems: "center",
          height: "40px",
          width: "40px",
          backgroundColor: isLastItemVisible ? "rgba(226, 232, 240, 0.6)" : "#0f172a",
          color: isLastItemVisible ? "#94a3b8" : "#ffffff",
          borderRadius: "50%",
          border: "none",
          cursor: isLastItemVisible ? "not-allowed" : "pointer",
          fontSize: "18px",
          fontWeight: "bold",
          zIndex: 2,
        }}
      >
        ›
      </button>
    );
  }

  useEffect(() => {
    getAllNews().then((result) => {
      if (result && result.news) {
        setInitialNews(result.news);
        setNewsData(result.news);
        const count = Object.keys(result.news).length;
        setTotalPage(Math.ceil(count / 12) || 1);
      }
      setIsLoading(false);
    });
  }, [page, idCategory]);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleCategory = (catId) => {
    setIdCategory(catId);
    setNewsData(initialNews);
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    if (query !== "") {
      const filtered = Object.values(initialNews).filter(
        (data) => data.title && data.title.toLowerCase().indexOf(query) > -1
      );
      setNewsData(filtered);
    } else {
      setNewsData(initialNews);
    }
  };

  const categories = [
    { id: 0, label: "Semua Kategori" },
    { id: 1, label: "Tips & Bisnis" },
    { id: 2, label: "Update Partner" },
    { id: 3, label: "Info F&B" },
  ];

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>Blog &amp; Berita Seputar F&amp;B | UR</title>
        <meta name="title" content="Blog & Berita Seputar F&B | UR" />
        <meta
          name="description"
          content="Wawasan terbaru seputar tren bisnis kuliner, tips pengelolaan restoran, dan update fitur UR POS & Self Order."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ur-hub.com/blog" />
      </MetaTags>

      {/* Hero Section */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "64px",
          backgroundColor: "#0f172a",
          color: "#ffffff",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center" justify="space-between">
            <Grid item xs={12} md={7}>
              <div
                style={{
                  color: "#DE148C",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  marginBottom: "12px",
                }}
              >
                Wawasan &amp; Artikel
              </div>

              <Typography
                variant="h1"
                style={{
                  fontWeight: 800,
                  fontSize: "clamp(2rem, 4vw, 3.2rem)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  marginBottom: "14px",
                }}
              >
                Blog &amp; Berita Restoran
              </Typography>

              <Typography
                variant="subtitle1"
                style={{
                  color: "#94a3b8",
                  fontSize: "15px",
                  lineHeight: 1.6,
                  maxWidth: "520px",
                }}
              >
                Temukan tips operasional cafe, panduan mengoptimalkan omset, dan berita terbaru seputar industri kuliner.
              </Typography>
            </Grid>

            {/* Illustration */}
            <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
              <img
                src="https://res.cloudinary.com/urhub/image/upload/v1791947918/promo.webp"
                alt="Blog Illustration"
                style={{
                  maxHeight: "220px",
                  width: "auto",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Search & Category Filter Section */}
      <section style={{ padding: "32px 0", backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
        <Container maxWidth="lg">
          <Grid container spacing={2} alignItems="center" justify="space-between">
            {/* Search Input */}
            <Grid item xs={12} md={5}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  border: "1px solid #e2e8f0",
                }}
              >
                <SearchIcon style={{ color: "#94a3b8", fontSize: "20px" }} />
                <input
                  type="text"
                  placeholder="Cari artikel seputar UR..."
                  onChange={handleSearch}
                  style={{
                    border: "none",
                    outline: "none",
                    width: "100%",
                    fontSize: "14px",
                    color: "#0f172a",
                    fontFamily: "inherit",
                  }}
                />
              </div>
            </Grid>

            {/* Category Pills */}
            <Grid item xs={12} md={7}>
              <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "flex-end" }}>
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => handleCategory(cat.id)}
                    style={{
                      padding: "6px 14px",
                      borderRadius: "6px",
                      border: idCategory === cat.id ? "1px solid #DE148C" : "1px solid #e2e8f0",
                      backgroundColor: idCategory === cat.id ? "#DE148C" : "#ffffff",
                      color: idCategory === cat.id ? "#ffffff" : "#64748b",
                      fontWeight: 500,
                      fontSize: "13px",
                      cursor: "pointer",
                      transition: "all 0.15s ease",
                    }}
                  >
                    {cat.label}
                  </button>
                ))}
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Article Showcase */}
      <section style={{ padding: "48px 0 80px 0" }}>
        <Container maxWidth="lg">
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "60px 0" }}>
              <CircularProgress style={{ color: "#DE148C" }} />
            </div>
          ) : newsData && Object.keys(newsData).length > 0 ? (
            <div>
              <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
                {Object.entries(newsData).map((data, id) => (
                  <GetNews
                    key={id}
                    data={data}
                    itemId={id}
                    title={id}
                  />
                ))}
              </ScrollMenu>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "60px 0", color: "#64748b" }}>
              <p>Belum ada artikel yang cocok dengan pencarian Anda.</p>
            </div>
          )}

          {/* Pagination */}
          <div style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}>
            <Pagination
              count={totalPage}
              page={page}
              onChange={handleChangePage}
              color="primary"
            />
          </div>
        </Container>
      </section>
    </div>
  );
}
